import { actions } from './actions';
import { name } from './name';
import { url } from './url';

export const columns = [name, url, actions];
